
import { CatalogosProps } from "../interfaces/catalogos/CatalogosInterface";

export const catalogosList: CatalogosProps[] = [
    { id: '1', descripcion: 'Aplicación', path: '/administracion/catalogos/aplicacion' },
    { id: '2', descripcion: 'Estatus', path: '/administracion/catalogos/estatus' },
    { id: '3', descripcion: 'Tipo de sesión', path: '/administracion/catalogos/tipo-sesion' },
];
